import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './app.css';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router-dom';
import routes from './routes';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SplashScreen } from './components/splash-screen';
import { SettingsConsumer, SettingsProvider } from './contexts/settingsContext';
import { AuthConsumer, AuthProvider } from './contexts/GardianWebSSOAuthContext';
import { ImportStatusProvider } from './contexts/importStatusContext';
import { createTheme } from './theme';
import { createEmotionCache } from './utils/create-emotion-cache';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { LoadingProvider } from './contexts/loadingIndicatorContext';
import { VisitLogger } from './visitLogger';
const clientSideEmotionCache = createEmotionCache();

const App = (props) => {
    const content = useRoutes(routes);
    const { emotionCache = clientSideEmotionCache } = props;

    // make sure no one is here by mistake
    useEffect(() => {
        if (window.location.href.includes('web-'))
            if (!Cookies.get('dev')) {
                window.location.href = window.location.href.replace('web-', '');
            }
    }, []);

    return (
        <CacheProvider value={emotionCache}>
            <HelmetProvider>
                <Helmet>
                    <title>Portail-ARMGP</title>
                    <meta name="viewport" content="initial-scale=1, width=device-width" />
                </Helmet>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <AuthProvider>
                        <ImportStatusProvider>
                            <SettingsProvider>
                                <LoadingProvider>
                                    <SettingsConsumer>
                                        {({ settings }) => (
                                            <ThemeProvider theme={createTheme({ mode: settings.theme })}>
                                                <CssBaseline />
                                                <Toaster position="top-center" />
                                                <VisitLogger />
                                                <AuthConsumer>
                                                    {(auth) => (auth.isInitialized ? content : <SplashScreen />)}
                                                </AuthConsumer>
                                            </ThemeProvider>
                                        )}
                                    </SettingsConsumer>
                                </LoadingProvider>
                            </SettingsProvider>
                        </ImportStatusProvider>
                    </AuthProvider>
                </LocalizationProvider>
            </HelmetProvider>
        </CacheProvider>
    );
};


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
